"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRealTrials = getRealTrials;
function getRealTrials(corpus) {
    const totalRealTrials = corpus.filter((trial) => {
        return trial.assessmentStage === 'test_response';
    }).length;
    return totalRealTrials;
}
